import { render } from "./BaseNotification.vue?vue&type=template&id=43c972ac&scoped=true"
import script from "./BaseNotification.vue?vue&type=script&lang=js"
export * from "./BaseNotification.vue?vue&type=script&lang=js"

import "./BaseNotification.vue?vue&type=style&index=0&id=43c972ac&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43c972ac"]])

export default __exports__